module.exports = __webpack_public_path__ + "assets/img/slogan-4cef759b.png";